import Vue from 'vue'

export default {
    list() {
        return Vue.axios.get(`/online-pay-accounts`)
    },
    create(params) {
        return Vue.axios.post(`/online-pay-accounts/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/online-pay-accounts/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/online-pay-accounts/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/online-pay-accounts/${id}`)
    },
}
